module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPsAAAAsCAYAAACjSc4xAAAArklEQVR4nO3TQQ2AAAwEwYIsRCAWB8hBBRiAP8nOPPtqctllO6973u0fd+DfjrfvVqNBg9ghQuwQIXaIEDtEiB0ixA4RYocIsUOE2CFC7BAhdogQO0SIHSLEDhFihwixQ4TYIULsECF2iBA7RIgdIsQOEWKHCLFDhNghQuwQIXaIEDtEiB0ixA4RYocIsUOE2CFC7BAhdogQO0SIHSLEDhFihwixQ4TYIULsUDAzDyeKBDusZgSNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title_bg.png
// module id = lCsY
// module chunks = 1